import { render, staticRenderFns } from "./DetentionList.vue?vue&type=template&id=749a23d3&"
import script from "./DetentionList.vue?vue&type=script&lang=js&"
export * from "./DetentionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports